import type { CSSProperties } from "react";
import { Typography } from "antd";

// SMS opt-in disclosure shown next to every field where a client enters their
// phone number. Carriers (10DLC / A2P campaign review) check that the consent
// language is visible at the point of collection, so keep this wording in sync
// with the campaign's opt-in description and /client-terms section 3.
export default function SmsConsentNote({ style }: { style?: CSSProperties }) {
  return (
    <Typography.Paragraph type="secondary" style={{ fontSize: 12, lineHeight: 1.5, margin: "0 0 12px", ...style }}>
      By entering your phone number, you agree to receive appointment-related text messages
      (confirmations, reminders, waitlist openings and login codes) from the salon, sent via Hairplane.
      Message frequency varies. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
      Consent is not a condition of purchase. See our{" "}
      <a href="/client-terms" target="_blank" rel="noopener noreferrer">Client Terms</a> and{" "}
      <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
    </Typography.Paragraph>
  );
}
